<template>
  <div class="warning-history">
    <el-dialog title="预警信号"
      :visible.sync="params.flag"
      v-dialogDrag
      :modal="false"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body=false
      ref="whRef"
     :before-close="() =>params.flag && this.$parent.toggleProductView(this.params.productInfo.code)">
      <div class="query">
        <div class="datetime block">
          <label>起止时间：</label>
          <el-date-picker
            v-model="datetime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format='yyyy-MM-dd HH:mm:ss'
            :append-to-body='false'
            @change = "queryAlarmForCounty"
          >
          </el-date-picker>
        </div>
        <div class="area block">
          <label>地区：</label>
          <!-- <el-cascader
            popper-class="select-area"
            v-model="area"
            :options="options"
          ></el-cascader> -->
          <el-select
            v-model="area"
            placeholder="请选择地区"
            clearable
            size="small"
            class="select-area"
            transfer="true"
            multiple
            collapse-tags
            :popper-append-to-body="false"
            @clear="queryAlarmForCounty"
            @change="queryAlarmForCounty" >
            <el-option
              v-for="item in areaOptions"
              :key="item" :label="item"
              :value="item"
              >
            </el-option>
          </el-select>
        </div>
        <div class="download-btn">
          <el-button type="primary"  size="small" @click="handleDownload">下载</el-button>
        </div>
      </div>
      <div class="type-level">
        <div class="type block">
          <label>预警类型：</label>
          <el-checkbox-group v-model="checkedTypes" @change="queryAlarmForCounty">
            <el-checkbox v-for="item in types" :label="item.babel" :key="item.name">{{
              item.name
            }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="level block">
          <label>预警等级：</label>
          <el-checkbox-group v-model="checkedLevels"  @change="queryAlarmForCounty">
            <el-checkbox v-for="item in levels" :label="item.label" :key="item.name">{{
            item.name
            }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="main">
        <div class="warning-list">
          <el-table tooltip-effect="dark" :data="tableData" height="90%" style="width: 100%" empty-text="暂无预警信号">
            <el-table-column prop="ptime" width="155" label="发布时间">
            </el-table-column>
            <el-table-column
              prop="type"
              label="预警类型"
            ></el-table-column>
            <el-table-column
              prop="level"
              label="预警等级"
            ></el-table-column>
            <el-table-column
              prop="county"
              label="地区"
            ></el-table-column>
            <el-table-column
              prop="etime"
              width="155"
              label="解除时间"
            ></el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
            :page-size="pageSize" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
        <div class="stat">
          <div class="month">
            <div class="title">当月发布预警信号</div>
            <div class="content">
              <div v-show="monthY.length>0" id="month-chart2"></div>
              <div v-show="(monthY.length===0)" class="no-public">
                <span>当月无预警信号</span>
              </div>
            </div>
          </div>
          <div class="year">
            <div class="title">当年发布预警信号</div>
            <div class="content">
              <div v-show="pieData.length>0" id="year-chart2"></div>
              <div v-show="pieData.length===0" class="no-public">
                <span>今年无预警信号</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import echarts from '@/config/echarts/index.js'
import { handleDownload } from '@/utils/exportFile'
import { getMonthWarningOption, getYearWarningOption } from '@/config/echarts/option/warning.js'
import { apiData } from '../api/index'
export default {
  props: ['params'],
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      datetime: [],
      area: null,
      options: [
        {
          value: 'panyu',
          label: '番禺区',
          children: [{
            value: 'shiqiao',
            label: '市桥街'
          }, {
            value: 'dashi',
            label: '大石街'
          }]
        },
        {
          value: 'panyu',
          label: '番禺区',
          children: [{
            value: 'shiqiao',
            label: '市桥街'
          }, {
            value: 'dashi',
            label: '大石街'
          }]
        },
        {
          value: 'panyu',
          label: '番禺区',
          children: [{
            value: 'shiqiao',
            label: '市桥街'
          }, {
            value: 'dashi',
            label: '大石街'
          }]
        },
        {
          value: 'panyu',
          label: '番禺区',
          children: [{
            value: 'shiqiao',
            label: '市桥街'
          }, {
            value: 'dashi',
            label: '大石街'
          }]
        },
        {
          value: 'panyu',
          label: '番禺区',
          children: [{
            value: 'shiqiao',
            label: '市桥街'
          }, {
            value: 'dashi',
            label: '大石街'
          }]
        }
      ],
      // areaOptions: ['荔湾', '越秀', '海珠', '天河', '白云', '黄埔', '番禺', '花都', '萝岗', '南沙', '增城', '从化'],
      areaOptions: ['禅城', '南海', '顺德', '三水', '高明'],
      checkedTypes: [],
      types: [{ name: '台风', babel: 'A' }, { name: '寒冷', babel: 'D' }, { name: '雷雨大风', babel: 'G' }, { name: '森林火险', babel: 'J' }, { name: '暴雨', babel: 'B' }, { name: '道路结冰', babel: 'H' }, { name: '高温', babel: 'C' }, { name: '灰霾', babel: 'F' }, { name: '冰雹', babel: 'I' }],
      checkedLevels: [],
      levels: [{ name: '白', label: 1 }, { name: '蓝', label: 2 }, { name: '黄', label: 3 }, { name: '橙', label: 4 }, { name: '红', label: 5 }],
      tableData: [],
      monthY: [],
      pieData: []
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  created () {
    this.initData()
    this.queryAlarmForCounty()
    this.searchData()
  },
  methods: {

    // 初始化数据
    initData () {
      const currentTime = new Date().getTime()
      const startTime = this.$moment(currentTime - 86400000 * 30).format('YYYY-MM-DD HH:mm:ss')
      const endTime = this.$moment(currentTime).format('YYYY-MM-DD HH:mm:ss')
      this.datetime = [startTime, endTime]
    },

    // 获取预警信号数据
    async queryAlarmForCounty () {
      if (!this.datetime) {
        this.$message.error('预警时间不能为空!')
        return
      }
      const params = {
        stime: this.$moment(this.datetime[0]).format('YYYY-MM-DD HH:mm'),
        etime: this.$moment(this.datetime[1]).format('YYYY-MM-DD HH:mm'),
        county: this.area ? this.area : null,
        page: this.currentPage,
        pagesize: this.pageSize,
        signame: this.checkedTypes.length > 0 ? this.checkedTypes : null,
        siglevel: this.checkedLevels.length > 0 ? this.checkedLevels : null
      }
      const result = await apiData.queryAlarmForCounty(params)
      if (result.status === 200) {
        this.tableData = result.data.datas
        this.total = result.data.rows
      }

      // 对数据进行格式化
      this.tableData = this.tableData.map(item => {
        item.type = item.aname.slice(0, -2)
        item.level = item.aname.slice(-2)
        item.ptime = this.$moment(item.sttimeLong).format('YYYY-MM-DD HH:mm')
        item.etime = item.cltimeLong ? this.$moment(item.cltimeLong).format('YYYY-MM-DD HH:mm') : '--'
        return item
      })
    },
    async searchData () {
      const y = new Date().getFullYear()
      const m = (new Date().getMonth() + 1 + '').padStart(2, '0')
      const d = (new Date().getDate() + '').padStart(2, '0')
      const monthParams = {
        stime: y + '-' + m + '-' + '01 00:00',
        etime: y + '-' + m + '-' + d + ' 00:00',
        county: null,
        page: 1,
        pagesize: 300,
        signame: null,
        siglevel: null
      }
      const yearParams = {
        stime: y + '-01-01 00:00',
        etime: y + '-' + m + '-' + d + ' 00:00',
        county: null,
        page: 1,
        pagesize: 1000,
        signame: null,
        siglevel: null
      }

      const monthResult = await apiData.queryAlarmForCounty(monthParams)
      const yearResult = await apiData.queryAlarmForCounty(yearParams)
      this.monthData = monthResult.data.datas
      this.yearData = yearResult.data.datas

      // 获取X轴和Y轴得数据
      const monthOptionData = this.getXY(this.monthData)
      this.monthX = monthOptionData.x
      this.monthY = monthOptionData.y

      const yearOptionData = this.getXY(this.yearData)
      yearOptionData.x.forEach((item, index) => {
        this.pieData.push({ value: yearOptionData.y[index], name: item })
      })

      this.$nextTick(() => {
        this.monthWarning()
      })
    },

    // 获取X和Y轴的数据
    getXY (data) {
      const alarnValue = {}
      const alarnType = []
      data.forEach(item => {
        const flag = alarnType.some(name => item.aname.includes(name))
        const name = item.aname.slice(0, -2)
        if (!flag) {
          alarnType.push(name)
          alarnValue[name] = 0
        }
        alarnValue[name]++
      })
      return { x: Object.keys(alarnValue), y: Object.values(alarnValue) }
    },

    // 获取初始化echart
    monthWarning () {
      const monthChart = echarts.init(document.getElementById('month-chart2'))
      const option = getMonthWarningOption()
      option.xAxis.data = this.monthX
      option.xAxis.data = option.xAxis.data.map(item => {
        if (item.length > 2) {
          item = item.slice(0, 2) + '\n' + item.slice(2)
        }
        return item
      })
      option.series[0].data = this.monthY
      monthChart.setOption(option)
      const yearChart = echarts.init(document.getElementById('year-chart2'))
      const yearOption = getYearWarningOption()

      yearOption.series[0].data = this.pieData
      yearChart.setOption(yearOption)
      this.$nextTick(() => {
        monthChart.resize()
        yearChart.resize()
      })
      window.addEventListener('resize', () => {
        monthChart.resize()
        yearChart.resize()
      })
    },

    handleDownload () {
      const filterVal = ['ptime', 'type', 'level', 'county', 'etime']
      const header = ['发布时间', '预警类型', '预警等级', '地区', '解除时间']
      handleDownload(filterVal, this.tableData, header, '预警信号')
    },

    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.queryAlarmForCounty()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.queryAlarmForCounty()
    },
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.whRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.warning-history {
    pointer-events: none;
  .query {
    display: flex;
    position: relative;
    .download-btn{
      position: absolute;
      right: 0px;
       button {
        padding: 0.52vw 1.09vw 0.52vw;
        border: 0;
        cursor: pointer;
        font-size: 0.73vw;
        color: #ffffff;
        background: linear-gradient(204deg, #5E9CD9 0%, rgba(66, 139, 211, 0.46) 100%);
        border-radius: 0.31vw;
        border: 0.05vw solid rgba(255, 255, 255, 0.5);
      }
    }
    .datetime {
      margin-right: 2rem;
      .el-date-editor {
        font-size: 0.88rem;
        color: #FFF;
        height: 2.5rem;
        line-height: 2.5rem;
        /deep/.el-range__icon,
        /deep/ .el-range__close-icon {
          line-height: 2.5rem;
          height: 2.5rem;
        }
        /deep/.el-range-separator {
          line-height: 2.5rem;
          height: 2.5rem;
          font-size: 0.88rem;
          color: #FFF;
        }
        /deep/input {
          color: #FFF;
          font-size: 0.88rem;
        }
        /deep/input::-webkit-input-placeholder {
          font-size: 0.88rem;
        }
        /deep/input:-moz-placeholder {
          font-size: 0.88rem;
        }
        /deep/input:-ms-input-placeholder {
          font-size: 0.88rem;
        }
      }
    }
    .area {
      /deep/.el-cascader {
        line-height: 2.5rem;
        input {
          line-height: 2.5rem;
          height: 2.5rem;
          color: #FFF;
          font-size: 0.88rem;
        }
      }
    }
  }
  .type-level {
    display: flex;
    margin: 1.56rem 0;
    /deep/.el-checkbox-group {
      .el-checkbox {
        margin-right: 1.25rem;
        font-size: 0.88rem;
        .el-checkbox__inner {
          width: 0.875rem;
          height: 0.875rem;
          background: #5592CB;
        }
        .el-checkbox__inner::after {
          height: 0.4375rem;
          left: 0.25rem;
        }
        .el-checkbox__label {
          font-size: 0.88rem;
          padding-left: 0.3rem;
          color: #FFF;
        }
      }
    }
  }
  .block {
    display: flex;
    align-items: center;
    > label {
      display: inline-block;
      flex-shrink: 0;
      font-size: 0.94rem;
      font-weight: 600;
      color: #FFF;
    }
  }
  .main {
    display: flex;
    justify-content: space-between;
    flex: 1;
    position: relative;
    .stat{
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 0;
      width: 37%;
      height: 100%;
      box-sizing: border-box;
      padding-left: 28px;

        .title {
          font-size: 1rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #FFF;
        }

        .month {
          flex: 1;
          display: flex;
          flex-direction: column;

          .content {
            display: flex;
            flex: 1;
            position: relative;

            #month-chart2 {
              flex: 1;
              overflow: hidden;
            }

            .no-public {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
            }
          }
        }

        .year {
          flex: 1;
          display: flex;
          flex-direction: column;

          .content {
            display: flex;
            flex: 1;
            position: relative;

            .no-public {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
            }

            #year-chart2 {
              flex: 1;
              overflow: hidden;
            }
          }
        }

    }
    .warning-list {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 63%;
      .el-pagination {
          display: flex;
          height: 10%;
          justify-content: flex-end;
          align-items: center;
        }
      .el-table {
      background: transparent;
      text-align: center;

      /deep/ tr {
        background: transparent;
        th {
          text-align: center;
          border: 0;
          font-size: 0.88rem;
          font-weight: 600;
          color: #FFF;
          background: #3C7CB8;
        }
        td {
          text-align: center;
          font-size: 0.88rem;
          font-weight: 400;
          color: #FFF;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }
        .print {
          width: 1.13rem;
          height: 1.13rem;
          background: url("../assets/images/打印.png") no-repeat;
          border: 0;
          cursor: pointer;
          background-size: 1.13rem 1.13rem;
        }
        .image{
          margin: 0.52vw;
          width: 1.09vw;
          cursor: pointer;
        }
      }
      /deep/ tr:hover td{
          background: #3C7CB8 !important;
      }

      .new{
        margin-left: 0.52vw;
        background-color: #f56c6c;
        border-radius: 0.32vw;
         color: #fff;
         display: inline-block;
         font-size: 0.43vw;
         height: 0.94vw;
         line-height: 0.94vw;
         padding: 0.1vw 0.31vw;
         text-align: center;
         white-space: nowrap;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #273458;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #1b2230;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #0C4170;
      }
      /deep/.el-table__fixed-right-patch {
        background: #1b3b80;
        border: 0;
      }
    }
      .el-table::before {
        background: transparent;
      }
    }
  }
 .el-pagination{
        display: flex;
        justify-content: flex-end;
        align-items: center;
         /deep/ .el-pager li{
           background: transparent;
           color: #FFF;
         }
         /deep/ .el-pager li.active{
            color: #6FBEFF;
         }
        /deep/  .el-pagination__total{
          color: #FFF;
         }
         /deep/ .btn-prev,.btn-next{
           background: transparent;
           color: #FFF;
         }
          /deep/ .btn-next{
           background: transparent;
           color: #FFF;
         }
         /deep/ .el-icon{
          color:#afa7a7
         }
      }
    /deep/.el-dialog__wrapper {
      overflow: hidden;
      .el-dialog {
        width: 76rem;
        pointer-events: auto;
      }
    }
}

/deep/ .el-input__inner{
  background: #5592CB;
   color: #FFF;
}
/deep/ .el-input__inner::placeholder{
  color: #FFF;
}
/deep/ .el-range-input{
  background: #5592CB;
}
/deep/ .is-checked .el-checkbox__inner {
  background: #5592CB !important;
}
</style>
